import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import PencilToPaperRegular from './pencil-to-paper-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <PencilToPaperRegular {...validProps} />;
}

SvgComponent.iconName = 'pencilToPaperRegular';

export const PencilToPaperRegularIcon = svgIconWrapper(SvgComponent);
